import { Box, BoxProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface ContentContainerProps extends Omit<BoxProps, 'sx'> {
  children: ReactNode;
  sx?: SxProps<Theme>;
  padding?: 'large' | 'medium';
}

export function ContentContainer({
  children,
  sx,
  padding = 'large',
  ...props
}: ContentContainerProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: '8px',
        padding: padding === 'large' ? '48px' : '32px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
